import "../../SharedSiteCode/Scripts/locations-worker";

// right now we don't need anything that's not in the shared locations script